import React from 'react';
import { createNavigator, SwitchRouter, createSwitchNavigator } from 'react-navigation';
import {
  BillingTab, ProfileTab, PreferencesTab, ProfileScreen, GoalsTab,
  CommunityPartners, FitnessGoal, SkillLevel,
  SummaryDashboard,
} from 'fitbeat.react-native-components';
import { GridLayoutWithRightContent } from './Layouts/GridLayoutWithRightContent';
import { GridLayoutForLeftTabbedContent } from './Layouts/GridLayoutForLeftTabbedContent';
import { WrapWithBackLayout } from './Layouts/FullWidthBackLayout';

const isMobile = window.innerWidth <= 550;

const profileRouteConfig = {
  Goals: {
    screen: GoalsTab,
    path: 'goals',
  },
  PersonalSettings: {
    screen: ProfileTab,
    path: 'profile',
  },
  Preferences: {
    screen: PreferencesTab,
    path: 'preferences',
  },
  WorkoutPartners: {
    screen: CommunityPartners,
    path: 'workout-partners',
  },
  Billing: {
    screen: BillingTab,
    path: 'billing',
  },
  FitnessGoal: {
    screen: FitnessGoal,
    path: 'FitnessGoal',
  },
  SkillLevel: {
    screen: SkillLevel,
    path: 'SkillLevel',
  },
  Dashboard: {
    screen: SummaryDashboard,
    path: 'SummaryDashboard',
  },
};

const mobilProfileRouteConfig = {
  Profile: {
    screen: (props) => (
      <GridLayoutWithRightContent {...props}>
        <ProfileScreen {...props} />
      </GridLayoutWithRightContent>
    ),
    path: 'profile',
  },
  Goals: {
    screen: WrapWithBackLayout({
      title: 'Goals and Skill Level',
      backRoute: 'Profile',
    })(GoalsTab),
    path: 'goals',
  },
  FitnessGoal: {
    screen: WrapWithBackLayout({
      title: 'Fitness Goal',
      backRoute: 'Profile',
    })(FitnessGoal),
    path: 'FitnessGoal',
  },
  SkillLevel: {
    screen: WrapWithBackLayout({
      title: 'Skill Level',
      backRoute: 'Profile',
    })(SkillLevel),
    path: 'SkillLevel',
  },
  PersonalSettings: {
    screen: WrapWithBackLayout({
      title: 'Personal Settings',
      backRoute: 'Profile',
    })(ProfileTab),
    path: 'profile',
  },
  Preferences: {
    screen: WrapWithBackLayout({
      title: 'Preferences',
      backRoute: 'Profile',
    })(PreferencesTab),
    path: 'preferences',
  },
  WorkoutPartners: {
    screen: WrapWithBackLayout({
      title: 'Friends',
      backRoute: 'Profile',
    })(CommunityPartners),
    path: 'preferences',
  },
  Billing: {
    screen: WrapWithBackLayout({
      title: 'Billing',
      backRoute: 'Profile',
    })(BillingTab),
    path: 'billing',
  },
  Dashboard: {
    screen: WrapWithBackLayout({
      title: 'Dashboard',
      backRoute: 'Profile',
    })(SummaryDashboard),
    path: 'SummaryDashboard',
  },
};

class SwitchView extends React.Component {
  render() {
    const { state } = this.props.navigation;
    const activeKey = state.routes[state.index].key;
    const descriptor = this.props.descriptors[activeKey];
    const ChildComponent = descriptor.getComponent();
    return (
      <GridLayoutForLeftTabbedContent {...this.props}>
        <div className='menu-container grid-x content-top-padding full-vh'>
          <div className='cell medium-4 large-4 small-12 black'>
            <div className='drawer-container medium-cell-block-y submenu-list margin-top-0'>
              <ProfileScreen {...this.props} />
            </div>
          </div>
          <div id='right-content' className='cell medium-8 large-8 medium-cell-block-y overflow-y'>
            <ChildComponent {...this.props} />
          </div>
        </div>
      </GridLayoutForLeftTabbedContent>
    );
  }
}

function createSidebarTabNavigator(routeConfigMap, switchConfig = {}) {
  const router = SwitchRouter(routeConfigMap, switchConfig);
  const Navigator = createNavigator(SwitchView, router, switchConfig);
  return Navigator;
}

export const ProfileNavigationContainer = isMobile
  ? createSwitchNavigator(mobilProfileRouteConfig)
  : createSidebarTabNavigator(profileRouteConfig);
